import { Controller } from 'stimulus';
import {overrideLinkTargets} from "../../public/common";

export default class extends Controller {
  static targets = ['modal'];

  initialize() {
    if (this.hasModalTarget) {
      overrideLinkTargets({
        $containerEl: this.modalTarget,
        hrefTestFn: (href) => !/^#/.test(href)
      });
    }
  }
}
